var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 tco-perks-container"},[_c('WelcomeMessage',{attrs:{"textPath":'tco.perks.welcomeBanner'}}),_c('h1',{staticClass:"text-center my-4"},[_vm._v(_vm._s(_vm.$t("tco.perks.title")))]),_c('TcoProgress'),_c('TcoCards'),_c('TcoBlocks')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }